GoalAPIService = ($http, $q) ->
  getGoalSettings: (params) ->
    defer = $q.defer()
    $http.get('/api/settings/goal.json', params: params)
      .then(
        (resp) ->
          defer.resolve resp.data
      ,
        (error) ->
          defer.resolve
            avg_total_shot: null
            avg_putt: null
            rat_fairway_center: null
            rat_par_on: null
            rat_recovery: null
      )
    defer.promise

GoalAPIService.$inject = [
  '$http'
  '$q'
]

module.exports = GoalAPIService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/remote-api/goal-api-service.coffee